import { api } from '../../api'

export const deleteCourseService = async (
  courseId: string,
  creatorId: string
) => {
  await api.delete(`/api/backoffice/courses/${courseId}?creator=${creatorId}`)
}
